module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "rt-notice-center"
  }, [_c('ul', {
    staticClass: "notice-main"
  }, _vm._l((_vm.noticeList.slice(0, 100)), function(item) {
    return _c('li', {
      key: item.id
    }, [_c('rt-icon', {
      class: item.icon,
      attrs: {
        "name": ("rt-base-" + (item.icon)),
        "size": "14"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "notice-text"
    }, [_vm._v(_vm._s(item.text))])], 1)
  }), 0), _vm._v(" "), (_vm.showViewAll) ? _c('li', {
    staticClass: "look-all"
  }, [_c('span', {
    on: {
      "click": _vm.onViewAll
    }
  }, [_vm._v(_vm._s(_vm.$tx('查看全部', 'xpc.common.showAll')))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a9d9f9a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/noticecenter/rtNoticecenter.vue
// module id = 2046
// module chunks = 228